// extracted by mini-css-extract-plugin
export default {"videocontainer":"Video_videocontainer__wdY2w","videoelement":"Video_videoelement__rXftX"};